<template>
  <div class="d-flex pa-2 video-container">
    <div class="justify-right d-flex pl-2">
      <div class="video-image" :style="`background-image: url(${video.thumb_url || video.yt_thumb_url})`">
        <div class="video-overlay">
          <v-chip v-if="video.duration" color="#00000055" class="white--text" small label>
            {{ $helpers.lengthInMinutes(video.duration) }}
          </v-chip>

          <v-btn v-if="showDelete" icon small color="#00000055" class="delete-btn" @click.stop="$emit('delete', video)">
            <v-icon small color="red">mdi-delete</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column video-desc">
      <span v-if="video.channel" class="text-caption font-weight-bold channel-name">
        {{ video.channel.name }}
      </span>

      <span class="text-caption text-title video-title">
        {{ video.title }}
      </span>

      <div class="d-flex flex-column">
        <span class="text-caption font-weight-bold">
          {{ (video.views || 0).toLocaleString() }} {{ $t('views') }} •
          {{ (video.comments || 0).toLocaleString() }} {{ $t('comments') }}
        </span>

        <span v-if="video.publish_time" class="text-caption font-weight-bold">
          {{ $t('date') }} {{ moment(video.publish_time).format("DD/MM/YYYY") }}
        </span>
      </div>

      <div v-if="$slots.badge" class="d-flex flex-row align-center justify-space-between">
        <slot name="badge" />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    video: {
      id: Number,
      thumb_url: String,
      title: String,
      duration: Number,
      views: Number,
      comments: Number,
      publish_time: String,
    },
    showDelete: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.text-title {
  overflow: hidden;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-width: 220px;
}

.channel-name {
  max-width: 220px;
}

.video-image {
  height: 120px;
  aspect-ratio: 16 / 9;
  background: black;
  object-fit: cover;
  background-size: cover;
  background-position: center center;
  display: flex;
  align-items: flex-end;
}

.video-overlay {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px 4px;
}

.video-desc {
  flex: 1;
  max-width: 240px;
}

.video-container {
  flex-direction: row;
  position: relative;
}

.delete-btn {
  flex-shrink: 0;
  background-color: white;
}
</style>
